import { type Ref, ref, computed } from "vue";

export const useGlobalsSetup = () => {
  const loaderStatusState: Ref<boolean> = ref(false);
  const errorMessageState: Ref<string | null> = ref(null);
  const infoMessageState: Ref<string | null> = ref(null);

  const enableLoader = async () => {
    loaderStatusState.value = true;
  };

  const disableLoader = async () => {
    loaderStatusState.value = false;
  };

  const setErrorMessage = (message: string | null) => {
    errorMessageState.value = message;
  };

  const setInfoMessage = (message: string | null) => {
    infoMessageState.value = message;
  };

  const loaderStatus = computed(() => loaderStatusState.value);
  const errorMessage = computed(() => errorMessageState.value);
  const infoMessage = computed(() => infoMessageState.value);

  return {
    loaderStatusState,
    errorMessageState,
    infoMessageState,
    enableLoader,
    disableLoader,
    setErrorMessage,
    setInfoMessage,
    loaderStatus,
    errorMessage,
    infoMessage
  };
};
